import _ from 'lodash'
import $ from 'jquery'
import FilterDetail from '../../wizard/common/filter-detail'
import appDisplay from 'scoreboard/components/app-display'
import ReportFilterBadges from './report-filter-badges'

let EditableReportFilterBadge = ReportFilterBadges.extend({

	/**
	 * A Report filter badge specfically for editing and deleting report filters,
	 * note this does not handle dataset report filters, as those reports defer
	 * to the the shared dataset-filters.js view
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {boolean} [options.selected=null] the filter whose badge that should be initially selected
	 * @param {boolean} [options.defaultSelect=true] if true and only one badge is available it should be initially
	 * selected. This is ignored if options.selected is defined
	 * @param {Object} options.meta={report meta}  meta data to render the types of filters available
	 */
	initialize: function (options = {}) {
		options.filters = this.model.get('filters')
		ReportFilterBadges.prototype.initialize.apply(this, arguments)
		this._cachedSeeds = {}
	},

	clickFilter: function(e) {
		if ($(e.target).hasClass('delete')) { return }	//we're deleting the filter so ignore

		const filterCtx = this.getFilterCtxForEvent(e)

		//get metadata associated with a particular filter
		let filterKey = filterCtx.filterKey
		let metaObject = this.options.meta
		var meta = metaObject[filterKey]

		//filterCtx.filterValue is the raw data value of the filter, it is used to populate the filter's detail view
		//data is the filter data itself passed along to the filter-detail view
		var options = _.defaults({
			view: meta.form,
			filterKey: filterCtx.filterKey,
			data: _.cloneDeep(filterCtx.filterValue),
			filters: this.model.get('filters'),
			orgId: this.model.get('organizationId'),
			meta: this.options.meta,
			showProjectSelector: _.get(this.options, 'showProjectSelector', false)
		}, meta)

		//load initial data if provided and not cached
		options.seedData = this._cachedSeeds[filterKey]
		if (meta.seed && !options.seedData) {
			$.get({ url: meta.seed }).done(data => {
				options.seedData = this._cachedSeeds[filterKey] = data
				this._loadFilter(filterCtx, options)
			})
		} else {
			this._loadFilter(filterCtx, options)
		}
	},

	_loadFilter: function(filterCtx, options) {
		let detailView
		if (options.wizard) {
			//if the meta defines a wizard, use it when editing the filter
			detailView = new options.wizard(_.assign({showOrFilter: true}, options))
			if (detailView.start) {
				//using common component wizard (non-report wizard)
				detailView.start()
			} else {
				//using a view that embeds the report wizard
				detailView.render()
			}
		} else {
			detailView = new FilterDetail(options)
			appDisplay.dialog(detailView)
		}

		//pass of changed filter and it's context
		detailView.once('done', data => {
			this.model.setFilter(data, filterCtx.filterKey, filterCtx.filterIndex)
			this.trigger('change', data, filterCtx)
		})
	},

	deleteFilter: function(e) {
		let filterCtx = this.getFilterCtxForEvent(e)
		//Clone so cancel can go back to saved state #17953
		let filters = _.cloneDeep(this.model.get('filters'))
		filters[filterCtx.filterKey].splice(filterCtx.filterIndex, 1)

		//remove empty arrays so we can better detect no filters
		if (_.isEmpty(filters[filterCtx.filterKey])) {
			delete filters[filterCtx.filterKey]
		}

		//#40170 notify the deletion first since change filters will cause a fetch
		this.trigger('delete', filterCtx)
		this.model.unset('filters', {silent: true})
		this.model.set('filters', filters)
	}

})

export default EditableReportFilterBadge
EditableReportFilterBadge.__filename__ = 'reports/common/filter/editable-report-filter-badges.js'
